import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { courseActions } from "../../../_actions";
import { Courses } from "../../Courses/Courses";
import { FetchNext } from "../../Other/FetchNext/FetchNext";
import { useHistory, useLocation } from "react-router";

const CoursesContainer = ({
  isFetching,
  currentPage,
  totalPage,
  total,
  courses,
}) => {
  const dispatch = useDispatch();

  const location = useLocation();
  const history = useHistory();

  const { state, pathname } = location;
  const { filterCourse, subCourses } = state || {};
  const [Filter, setFilter] = useState({
    fliterCategory: null,
    filterSubCategory: null,
    fliterLevel: null,
  });

  const handleFetchNext =
    (isFetching, currentPage, totalPage) => (observer) => {
      if (!isFetching && currentPage < totalPage) {
        dispatch(
          courseActions.fetchCourses(
            ++currentPage,  
            Filter.fliterCategory,
            Filter.fliterLevel,
            Filter.filterSubCategory
          )
        );
      } else {
        observer.disconnect();
      }
    };

  useEffect(() => {
    if (!currentPage) {
      dispatch(courseActions.handleResetCourseList());
      dispatch(
        courseActions.fetchCourses(
          1,
          Filter.fliterCategory,
          Filter.fliterLevel,
          Filter.filterSubCategory
        )
      );
    } else {
      if (filterCourse === undefined || subCourses === undefined) {
        dispatch(courseActions.handleResetCourseList());
        dispatch(
          courseActions.fetchCourses(
            1,
            Filter.fliterCategory,
            Filter.fliterLevel,
            Filter.filterSubCategory
          )
        );
      }
    }
  }, [Filter]);

  useEffect(() => {
    if (filterCourse) {
      setFilter({
        fliterCategory: filterCourse,
        fliterLevel: null,
        filterSubCategory: subCourses,
      });
      dispatch(courseActions.handleResetCourseList());
      dispatch(
        courseActions.fetchCourses(
          1,
          filterCourse,
          Filter.fliterLevel,
          Filter.filterSubCategory
        )
      );
    }
  }, [filterCourse]);

  useEffect(() => {
    if (subCourses) {
      setFilter({
        fliterCategory: null,
        fliterLevel: null,
        filterSubCategory: subCourses,
      });
      dispatch(courseActions.handleResetCourseList());
      dispatch(
        courseActions.fetchCourses(
          1,
          null,
          Filter.fliterLevel,
          subCourses
        )
      );
    }
  }, [subCourses]);

  const handlefilterChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    history.replace(pathname, null);
    setFilter((prev) => {
      return {
        ...prev,
        [name]: value === "All Courses" ? null : value,
      };
    });
  };

  return (
    <>
      <Courses
        courses={courses}
        varient="courses"
        title="All Courses"
        total={total}
        isFetching={isFetching}
        handlefilterChange={handlefilterChange}
        Filter={Filter}
        setFilter={setFilter}
      />
      {courses.length > 0 && (
        <FetchNext
          isFetching={isFetching}
          currentPage={currentPage}
          handleFetchNext={handleFetchNext(isFetching, currentPage, totalPage)}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    courses: { all: allCourses },
    isFetching,
  } = state.course;
  return {
    isFetching: isFetching,
    courses: allCourses.courses || [],
    currentPage: allCourses.currentPage,
    totalPage: allCourses.totalPage,
    total: allCourses.total,
  };
};

export default connect(mapStateToProps)(CoursesContainer);
